import React, {useContext} from 'react';
import {EventCreateContext} from '~/CreateFabricInvitation/routes/EventCreateDesign/EventCreateContext';
import './UyoControl.sass';

// Import components
import {PhotoEditorHeader} from './components/PhotoEditorHeader';
import {ActionButtons} from './components/ActionButtons';
import {TransformSection} from './components/TransformSection';
import {FiltersSection} from './components/FiltersSection';

export const UyoControl = ({editorDisabled}) => {
  const {canvas, activeObjects} = useContext(EventCreateContext);
  const id = activeObjects?.[0]?.id;

  return (
    <div key={id} className={`uyo-control-container ${editorDisabled ? 'disabled' : ''}`}>
      <PhotoEditorHeader canvas={canvas} />

      <ActionButtons canvas={canvas} id={id} editorDisabled={editorDisabled} />

      <TransformSection canvas={canvas} />

      <FiltersSection canvas={canvas} />
    </div>
  );
};
